import { useStore, useStoreState } from "easy-peasy";
import React from "react";
import Accordion from "../../components/Accordion/Accordion";
import "./Contacts.scss";
import { getAddress, getCoord } from "../../utils/helper";
import { YMaps, Map, Placemark } from "react-yandex-maps";
const mainClass = "contactsStyles";

const Contacts = () => {
  const contacts = useStoreState((state) => state.contact.contacts);
  const phones = useStoreState((state) => state.phone.phones);
  const place = useStoreState((state) => state.place.place);

  return (
    <div className={mainClass}>
      <div className={mainClass + "-navLine"}></div>
      <div className={mainClass + "-container container"}>
        <div className={mainClass + "-main"}>
          <div className={mainClass + "-header"}>Контакты</div>
          <div className={mainClass + "-accardionContainer"}>
            <Accordion title={"Общие контакты"} type={1} data={contacts} />
          </div>
          <div className={mainClass + "-accardionContainer"}>
            <Accordion title={"Телефоны отделов"} type={1} data={phones} />
          </div>
          {place.id && <div className={mainClass + "-mapContainer"}>
            <YMaps>
              <Map
                width={"100%"}
                height={500}
                state={{
                  center: getCoord(place.map),
                  zoom: 15,
                }}
              >
                <Placemark
                  geometry={getCoord(place.map)}
                  properties={{
                    balloonContentHeader: place.title,
                    balloonContent: `<p>${getAddress(place.map)}</p><p>${
                      place.phone
                    }</p><p>${place.schedule}</p>`,
                    hintContent: `
                        ${getAddress(place.map)}
                        `,
                  }}
                  modules={["geoObject.addon.hint", "geoObject.addon.balloon"]}
                />
              </Map>
            </YMaps>
          </div>}
        </div>
      </div>
    </div>
  );
};

Contacts.getInitialProps = async (props) => {
  if (props.isServer) {
    await props.store.dispatch.phone.getPhones();
    await props.store.dispatch.place.getPlace();
  } else {
    const store = require("../../client");
    if (store.default.getState().phone.phones.length < 1) {
      await store.default.dispatch.phone.getPhones();
    }
    if (!store.default.getState().place.place.id) {
      await store.default.dispatch.place.getPlace();
    }
  }
  return { whatever: "stuff" };
};

export default Contacts;
